module.exports = "<p>\r\n  statclient works!\r\n</p>\r\n"